import React, { useEffect, useState ,useContext} from "react";
import { Button, Row, Col, Radio, Tag } from "antd";
import { SaveOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Paper,
  TextField,
  Box,
  Typography,
  Divider,
  Button as MUIButton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { URL as BASE_URL } from "../config";
import { LoaderContext } from "../Components/dashboard";

const themeColor = "#ff002b";

export default function AddPdfForm() {
  const { setLoading } = useContext(LoaderContext);
  const { id } = useParams();
  const navigate = useNavigate();

  const [pdfName, setPdfName] = useState("");
  const [isActive, setIsActive] = useState(1);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfPreview, setPdfPreview] = useState("");
  const [saving, setSaving] = useState(false);
const [pdfRemoved, setPdfRemoved] = useState(false);
const [categories, setCategories] = useState([]);
const [fkpdfCategoryId, setFkpdfCategoryId] = useState(null);

  const [mode, setMode] = useState(id ? "edit" : "create");

  useEffect(() => {
  let isMounted = true;
  const startTime = Date.now();

  setLoading(true); 

  const init = async () => {
    if (id) {
      await fetchDetails(); 
    }

    const elapsed = Date.now() - startTime;
    const remaining = 1500 - elapsed;

    setTimeout(() => {
      if (isMounted) {
        setLoading(false); 
      }
    }, remaining > 0 ? remaining : 0);
  };

  init();

  return () => {
    isMounted = false;
  };
}, [id]);
  useEffect(() => {

      fetchCategories(); 

    setMode(id ? "edit" : "create");
    if (id) fetchDetails();
  }, [id]);


  const fetchDetails = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/addpdf/${id}`);
      const data = res.data.data;

      setPdfName(data.pdfName || "");
      setIsActive(data.isActive ?? 1);
      setFkpdfCategoryId(data.fkpdfCategoryId || null);
setPdfRemoved(false);

      if (data.pdf) {
        setPdfPreview(`${BASE_URL}${data.pdf}`);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load PDF details");
    }
  };

const fetchCategories = async () => {
  try {
    const res = await axios.get(`${BASE_URL}/pdfcategorys`);
    setCategories(res.data.data || []);
  } catch (err) {
    console.error(err);
    toast.error("Failed to load categories");
  }
};

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
      setPdfPreview(file.name);
    } else {
      toast.error("Only PDF files allowed");
    }
  };

const removeFile = () => {
  setPdfFile(null);
  setPdfPreview("");
  setPdfRemoved(true); 
};


  const clearForm = () => {
    setPdfName("");
    setIsActive(1);
    setPdfFile(null);
    setPdfPreview("");
    setFkpdfCategoryId(null);
  };

 
  const handleSave = async () => {
  if (saving) return;

  if (!pdfName.trim()) {
    toast.error("PDF name is required");
    return;
  }

  try {
    setSaving(true);

    const formData = new FormData();
    formData.append("pdfName", pdfName);
    formData.append("isActive", isActive);

   if (fkpdfCategoryId) {
  formData.append("fkpdfCategoryId", fkpdfCategoryId);
}

    if (pdfRemoved) {
      formData.append("removePdf", "1");
    }

    
    if (pdfFile) {
      formData.append("pdf", pdfFile);
    }

    if (mode === "edit") {
      await axios.patch(`${BASE_URL}/addpdf/${id}`, formData);
      toast.success("PDF updated successfully");

      clearForm();
      setMode("create");
      window.history.replaceState({}, "", "/dashboard/addpdf");
    } else {
      await axios.post(`${BASE_URL}/addpdf`, formData);
      toast.success("PDF uploaded successfully");

      clearForm();
    }
  } catch (err) {
    console.error(err);
    toast.error("Save failed");
  } finally {
    setSaving(false);
  }
};
  return (
    <Box sx={{ p: { xs: 0.1, md: 1 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1, md: 3 }, borderRadius: 3 }}>
       
        <Box display="flex" justifyContent="center" mt={1.5} mb={1.5}>
          <Box
            sx={{
              background: `linear-gradient(90deg, ${themeColor}, #ff6a6a)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                fontWeight: 900,
                color: "#fff",
                letterSpacing: "0.7px",
                textTransform: "uppercase",
              }}
            >
              Add PDF
            </Typography>
          </Box>
        </Box>

        <Divider
          sx={{
            mb: { xs: 2, md: 3 },
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
            borderRadius: 5,
          }}
        />

       
        <Row gutter={[16, 16]} align="middle">
       
          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              PDF Name
            </Typography>
            <TextField
              size="small"
              fullWidth
              placeholder="Enter PDF name"
              value={pdfName}
              onChange={(e) => setPdfName(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  minHeight: 40,
                  "& fieldset": { borderColor: "#ccc" },
                  "&:hover fieldset": { borderColor: "#aaa" },
                  "&.Mui-focused fieldset": { borderColor: "#aaa" },
                },
                "& .MuiInputBase-input": {
                  fontSize: "13px",
                  padding: "8.5px 12px",
                },
              }}
            />
          </Col>

         <Col xs={24} sm={12} md={8}>
  <Typography
    fontWeight={600}
    mb={0.5}
    sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
  >
    PDF Category
  </Typography>

  <Autocomplete
  options={categories}
  getOptionLabel={(option) => option.pdfCategoryName || ""}
  value={
    categories.find(
      (c) => c.pdfCategoryId === fkpdfCategoryId
    ) || null
  }
  onChange={(e, newValue) => {
    if (newValue) {
      setFkpdfCategoryId(newValue.pdfCategoryId);
    } else {
      setFkpdfCategoryId(null);
    }
  }}
  ListboxProps={{
    sx: {
      maxHeight: 180,
      overflowY: "auto",
      fontSize: "13px",
      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#bbb",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    },
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      minHeight: 40,
      "& fieldset": { borderColor: "#ccc" },
      "&:hover fieldset": { borderColor: "#aaa" },
      "&.Mui-focused fieldset": { borderColor: "#aaa" },
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      padding: "8.5px 12px",
    },
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Select PDF Category"
    />
  )}
/>

</Col>

          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={1}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              Status
            </Typography>
            <Radio.Group
              value={isActive}
              onChange={(e) => setIsActive(e.target.value)}
            >
              <Radio value={1}>
                <Tag color="green">Active</Tag>
              </Radio>
              <Radio value={0}>
                <Tag color="red">Deactive</Tag>
              </Radio>
            </Radio.Group>
          </Col>

          
          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={1}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              Upload PDF
            </Typography>

            <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
              <input
                id="pdf-upload"
                type="file"
                accept="application/pdf"
                hidden
                onChange={handleFileChange}
              />
              <label htmlFor="pdf-upload">
                <MUIButton
                  variant="outlined"
                  component="span"
                  sx={{ fontWeight: 600, fontSize: { xs: "12px", md: "14px" }, borderColor: "#aaa", color: "#8b8989", "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" } }}
                >
                  Upload PDF
                </MUIButton>
              </label>

              {pdfPreview && (
                <Box
                  position="relative"
                  px={1.5}
                  py={0.5}
                  border={`1px solid ${themeColor}`}
                  borderRadius={1}
                  fontSize={12}
                >
                  {pdfPreview}
                  <CloseIcon
                    onClick={removeFile}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      cursor: "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      fontSize: 16,
                      color: themeColor,
                    }}
                  />
                </Box>
              )}
            </Box>
          </Col>
        </Row>

       
        <Box display="flex" justifyContent="end" mt={4} gap={1.5}>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={handleSave}
            loading={saving}         
  disabled={saving} 
            style={{
              background: themeColor,
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13,
            }}
          >
            {mode === "edit" ? "Update" : "Save"}
          </Button>

          <Button
            icon={<InfoCircleOutlined />}
            onClick={() => navigate("/dashboard/addpdflist")}
            style={{
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13
              ,color:"red",borderColor:"red"
            }}
            onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#ffe6e9";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "transparent";
  }}
          >
            Details
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
